module.exports = __webpack_public_path__ + "media/images/warsaw_coffee_tour_green-74395886a34b62f939812ea3e80fd614.png";